import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { resources as SuperLogin } from './SuperLogin';
import permissions from "app/permissions";

export const resources = {
  isMenu: true,
  icon: <AdminPanelSettingsIcon />,
  name: "Admin Panel",
  title: "Админ Панел",
  subMenu: [SuperLogin],
  permission: permissions.adminOnly
};